import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { KpiCard } from "@/components/shared/Common";
import { ArrowLeft, ClipboardText, CheckCircle, Gauge, Star } from "@phosphor-icons/react";
import { Progress } from "@/components/ui/progress";

export default function EmployeeDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [emp, setEmp] = useState(null);

  useEffect(() => { api.get(`/employees/${id}`).then(r => setEmp(r.data)); }, [id]);
  if (!emp) return <div className="text-sm text-muted-foreground mono">Loading…</div>;

  return (
    <div>
      <Button variant="ghost" size="sm" onClick={() => nav("/workforce")} className="mb-3"><ArrowLeft size={14} className="mr-1" /> Workforce</Button>
      <div className="flex items-center gap-4 mb-6">
        <div className="w-14 h-14 rounded-md bg-primary/10 text-primary grid place-items-center display text-xl font-semibold">
          {emp.name?.[0]}
        </div>
        <div>
          <div className="eyebrow text-muted-foreground">{emp.team}</div>
          <h1 className="display text-3xl font-semibold tracking-tighter">{emp.name}</h1>
          <div className="text-sm text-muted-foreground mono">{emp.email} · {emp.shift} shift</div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <KpiCard label="Workload" value={emp.workload} sub="Active cases" icon={ClipboardText} />
        <KpiCard label="Completed" value={emp.completed} sub="All-time" icon={CheckCircle} accent="text-emerald-500" />
        <KpiCard label="Performance" value={`${emp.performance_score}`} sub="Score" icon={Gauge} />
        <KpiCard label="Quality" value={`${emp.quality_score}`} sub="Score" icon={Star} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="border rounded-md p-5 bg-card">
          <div className="eyebrow text-muted-foreground mb-3">Competency matrix</div>
          <div className="space-y-3">
            {(emp.skills || []).map(s => (
              <div key={s.skill}>
                <div className="flex items-center justify-between text-xs mb-1">
                  <div className="font-medium">{s.skill}</div>
                  <div className="mono">L{s.level}/5</div>
                </div>
                <Progress value={(s.level / 5) * 100} className="h-1.5" />
              </div>
            ))}
            {(!emp.skills || emp.skills.length === 0) && <div className="text-sm text-muted-foreground">No skills recorded</div>}
          </div>
        </div>
        <div className="border rounded-md p-5 bg-card">
          <div className="eyebrow text-muted-foreground mb-3">Details</div>
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between"><dt className="text-muted-foreground">Availability</dt><dd className="capitalize">{emp.availability}</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">Capacity</dt><dd>{emp.capacity_hours}h/day</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">Shift</dt><dd>{emp.shift}</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">Team</dt><dd>{emp.team}</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">Joined</dt><dd className="mono text-xs">{emp.joined_at?.slice(0, 10)}</dd></div>
          </dl>
        </div>
      </div>
    </div>
  );
}
